/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { alpha, Theme } from "@mui/material";

export const areasOfLawOverviewStyle = {
  mainSection: (theme: Theme) => ({
    position: "relative",
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.up("lg")]: {
      paddingBottom: "6rem",
    },
  }),
  headline: {
    position: "absolute",
    alignItems: "center",
  },
  chip: (theme: Theme) => ({
    backgroundColor: alpha(theme.palette.background.default, 0.44),
  }),
  logo: {
    maxWidth: "100%",
    height: "auto",
    paddingInline: "1rem",
  },
  backgroundImage: (theme: Theme) => ({
    maxWidth: "100%",
    height: "auto",
    color: theme.palette.brand.frost,
  }),
  tile: (theme: Theme) => ({
    [theme.breakpoints.up("lg")]: {
      position: "absolute",
      width: "max(20rem, 20%)",
      transform: "translateX(-50%)",
    },
  }),
  tileActive: (theme: Theme) => ({
    [theme.breakpoints.up("lg")]: {
      "&.Mui-expanded": {
        marginTop: "0.5rem",
      },
      boxShadow: theme.shadows[6],
      zIndex: 1,
    },
  }),
  tileContent: (theme: Theme) => ({
    [theme.breakpoints.up("lg")]: {
      padding: "0 1rem 2rem 1rem",
    },
  }),
  tiles: [
    {
      left: "50%",
      top: "5%",
    },
    {
      top: "25%",
      left: "85%",
    },
    {
      top: "60%",
      left: "80%",
    },
    {
      top: "80%",
      left: "50%",
    },
    {
      top: "60%",
      left: "20%",
    },
    {
      top: "25%",
      left: "15%",
    },
  ],
};
